import { localize } from "utils/localizer";

const i18n = {
    all: {
        en: "All",
        de: "Alle",
    },
    bornAfter: {
        en: "Born after",
        de: "Geboren nach",
    },
    bornBefore: {
        en: "Born before",
        de: "Geboren vor",
    },
    gender: {
        en: "Gender",
        de: "Geschlecht",
    },
    genders: {
        en: {
            male: "Male",
            female: "Female",
            diverse: "Diverse",
            none: "None",
        },
        de: {
            male: "Männlich",
            female: "Weiblich",
            diverse: "Divers",
            none: "Keine Angabe",
        },
    },
    memberOfClub: {
        en: "Member of location",
        de: "Mitglied der Sportstätte",
    },
};

export default localize(i18n);
